module.exports = __webpack_public_path__ + "img/spins_11.aab55812.png";